import Vue from "vue";

const dashboardBus = new Vue();

export default dashboardBus;
